import MultiChoiceItem from '../../../types/MultiChoiceItem';

export default (data: MultiChoiceItem[]): boolean => !data.every(({ checked }) => checked);
